const ProjectStore = (function () {
    const STORE_KEY = 'paintedforever:projects:v1';
    const ACTIVE_KEY = 'paintedforever:last_active_project_id';

    function getAll() {
        try {
            return JSON.parse(localStorage.getItem(STORE_KEY) || '[]');
        } catch (e) {
            console.error('Error reading ProjectStore', e);
            return [];
        }
    }

    function getById(projectId) {
        return getAll().find(p => p.project_id === projectId) || null;
    }

    function getIncomplete() {
        return getAll().filter(p => p.status === 'in_progress').sort((a, b) => {
            return new Date(b.updated_at) - new Date(a.updated_at);
        });
    }

    function saveAll(projects) {
        localStorage.setItem(STORE_KEY, JSON.stringify(projects));
    }

    function generateUUID() {
        try { return crypto.randomUUID(); }
        catch (e) { return 'uuid_' + Date.now() + '_' + Math.random().toString(36).slice(2); }
    }

    function create({ product_id, variant_id, product_handle, product_title, product_thumbnail_url, step_total }) {
        const project = {
            schema_version: 1,
            project_id: generateUUID(),
            product_id,
            variant_id: variant_id || null,
            product_handle,
            product_title,
            product_thumbnail_url: product_thumbnail_url || null,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
            status: 'in_progress',
            step_total: step_total || 4,
            step_completed: 0,
            last_step_key: 'step1',
            form_data: {},
            assets: [],
            cart: {}
        };

        const projects = getAll();
        projects.push(project);
        saveAll(projects);
        setLastActive(project.project_id);
        return project;
    }

    function update(projectId, patchObj) {
        const projects = getAll();
        const index = projects.findIndex(p => p.project_id === projectId);
        if (index === -1) return null;

        projects[index] = {
            ...projects[index],
            ...patchObj,
            updated_at: new Date().toISOString()
        };

        saveAll(projects);
        return projects[index];
    }

    function setLastActive(projectId) {
        localStorage.setItem(ACTIVE_KEY, projectId);
    }

    function getLastActive() {
        return localStorage.getItem(ACTIVE_KEY);
    }

    function remove(projectId) {
        const projects = getAll().filter(p => p.project_id !== projectId);
        saveAll(projects);
    }

    function archive(projectId) {
        update(projectId, { status: 'abandoned' });
    }

    function markCompleted(projectId, meta = {}) {
        update(projectId, {
            status: 'completed',
            cart: meta
        });
    }

    function migrateIfNeeded() {
        // For future schema migrations
    }

    // Initialize
    migrateIfNeeded();

    return {
        getAll,
        getById,
        getIncomplete,
        create,
        update,
        setLastActive,
        getLastActive,
        remove,
        archive,
        markCompleted,
        migrateIfNeeded
    };
})();

window.ProjectStore = ProjectStore;
